export const LocalizationSymbols = {
    LocalizationService: Symbol.for("LocalizationService")
}